var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"placement":"right"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.detail))]),_c('div',{on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.overview))])])}
var staticRenderFns = []

export { render, staticRenderFns }